export default () => {
    const floatingBar = document.getElementById('floating-bar');
    if (floatingBar === null) {
        return;
    }

    const triggerScroll = 0.15;
    let isFloatingBarVisible = false;

    window.addEventListener('scroll', function () {
        let scrollDistance = window.scrollY;
        let documentHeight = document.documentElement.scrollHeight;
        let windowHeight = window.innerHeight;

        if (scrollDistance > (documentHeight - windowHeight) * triggerScroll && !isFloatingBarVisible) {
            floatingBar.style.opacity = '0';
            floatingBar.style.display = 'block';
            fadeIn(floatingBar);
            isFloatingBarVisible = true;
            document.body.classList.add('floating-open');
        } else if (scrollDistance <= (documentHeight - windowHeight) * triggerScroll && isFloatingBarVisible) {
            fadeOut(floatingBar);
            isFloatingBarVisible = false;
            document.body.classList.remove('floating-open');
        }
    });

    function fadeIn(element) {
        let opacity = 0;

        let fadeInInterval = setInterval(function () {
            if (opacity < 1) {
                opacity += 0.1;
                element.style.opacity = opacity;
            } else {
                clearInterval(fadeInInterval);
            }
        }, 20);
    }

    function fadeOut(element) {
        let opacity = 1;

        let fadeOutInterval = setInterval(function () {
            if (opacity > 0) {
                opacity -= 0.1;
                element.style.opacity = opacity;
            } else {
                clearInterval(fadeOutInterval);
                element.style.display = 'none';
            }
        }, 20);
    }
}